
import { useState } from 'react';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Solution from './components/Solution';
import Features from './components/Features';
import GuidanceComparison from './components/GuidanceComparison';
import TargetAudience from './components/TargetAudience';
import Waitlist from './components/Waitlist';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Hero />
      <Problem />
      <Solution />
      <Features />
      <GuidanceComparison />
      <TargetAudience />
      <Waitlist />
      <Footer />
    </div>
  );
}
